"use client";

import React from "react";
import { MapPin, Clock, Wrench, ShieldCheck, PhoneCall, CalendarCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const servicesData = [{
  title: "קרבה למרכז הרפואי שיבא",
  description: "אנו מספקים מענה מיידי למטופלים המשתחררים מבית החולים תל השומר (שיבא), עם מטפלים סיעודיים הזמינים להגעה מהירה לכל שכונות רמת גן.",
  icon: MapPin
}, {
  title: "זמינות מיידית 24/7",
  description: "אנו מבינים שצורך סיעודי יכול לעלות בכל רגע. המוקד שלנו פעיל מסביב לשעון כדי להבטיח הצבת מטפל מקצועי בביתכם תוך פחות מ-5 שעות.",
  icon: Clock
}, {
  title: "ליווי מקצועי בבתי חולים",
  description: "זקוקים להשגחה צמודה בבית החולים איכילוב או שיבא? המטפלים שלנו מנוסים בליווי מאושפזים ובמתן סיוע אישי ומסור במהלך השהות בבית החולים.",
  icon: Wrench
}, {
  title: "ביטחון ושקט נפשי",
  description: "כל המטפלים שלנו עוברים סינון קפדני והכשרות מקצועיות. אנו מתחייבים לשירות אמין, בטוח ומכבד עבור יקיריכם ברגעים המאתגרים ביותר.",
  icon: ShieldCheck
}, {
  title: "התאמה אישית מהירה",
  description: "אבחון צרכים טלפוני מהיר מאפשר לנו להתאים את המטפל הנכון ביותר למצב הרפואי והאישי של המטופל, כולל התאמה שפתית ותרבותית.",
  icon: CalendarCheck
}, {
  title: "ייעוץ והכוונה למשפחות",
  description: "צוות המומחים שלנו ברמת גן זמין עבורכם לכל שאלה בנושא זכויות סיעוד, סיוע מול קופות החולים והדרכה ראשונית לטיפול בבית.",
  icon: PhoneCall
}];
export default function LocalServicesInMontreal() {
  return <section data-section-id="252498" id="מיקומים-וביתנות-ברמת-גן" className="w-full py-16 md:py-24 lg:py-32 bg-background text-foreground">
      <div className="page-container">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-12 md:mb-20">
          <Badge variant="secondary" className="mb-4 text-primary bg-secondary/10">
            שירות מקומי ברמת גן
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            מומחי הסיעוד שלכם ברמת גן והסביבה
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default mb-4">
            פתרונות סיעוד מהירים, אמינים ומקצועיים בקרבת בתי החולים שיבא ואיכילוב. אנחנו כאן כדי להעניק לכם שקט נפשי וטיפול מסור בבית או בבית החולים.
          </p>
          <p className="text-base text-muted-foreground font-default leading-relaxed">
            אנו מספקים שירותי <Link to="/HomePage" className="text-primary hover:underline">סיעוד מיידי</Link> בפריסה ארצית. אם אתם מחפשים <Link to="/NursingCaregiverInTelAvivWithinFiveHoursPage" className="text-primary hover:underline">מטפל סיעודי בתל אביב</Link>, <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="text-primary hover:underline">שירותי סיעוד בירושלים</Link> או <Link to="/NursingCareProviderInHaifaWithinHoursPage" className="text-primary hover:underline">מטפלים בחיפה</Link>, הצוות שלנו ערוך להגעה מהירה. תוכלו להתרשם ממגוון ה<Link to="/ServicesCitiesArticlesPage" className="text-primary hover:underline">שירותים</Link> שלנו או לקרוא עוד ב<Link to="/ProfessionalBlogPage" className="text-primary hover:underline">בלוג המקצועי</Link> על זכויותיכם.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {servicesData.map((service, index) => {
          const Icon = service.icon;
          return <Card key={index} data-index={index} className="border-border/50 shadow-md hover:shadow-lg transition-all duration-300 bg-card group rounded-lg">
                <CardHeader className="pb-4">
                  <div className="size-14 rounded-lg bg-accent flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="size-7 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-xl font-bold font-default text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-default">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button size="lg" className="w-full sm:w-auto font-bold text-base bg-primary text-primary-foreground rounded-lg" asChild>
            <Link to="/NursingCareInRamatGanWithinHoursPage">
              מטפל סיעודי ברמת גן עכשיו
            </Link>
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto font-bold text-base border-primary text-primary hover:bg-accent rounded-lg" asChild>
            <Link to="/ProfessionalBlogPage">
              למידע על זכויות סיעוד
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}